$(function (){
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-start',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
            actions: 'justify-content-center',
            confirmButton: 'btn btn-primary text-white',
            cancelButton: 'btn btn-info text-white',
        },
        confirmButtonText: "تم",
        cancelButtonText: "موافق",
        buttonsStyling: false,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
    const Confirmation = Swal.mixin({
        customClass: {
            reverseButtons: true,
            confirmButton: 'btn btn-primary text-white me-3',
            denyButton: 'btn text-danger2',
        },
        confirmButtonText: "موافق",
        denyButtonText: "لا",
        buttonsStyling: false
    })

    const Form = Swal.mixin({
        customClass: {
            reverseButtons: true,
            confirmButton: 'btn btn-primary text-white me-2',
            cancelButton: 'btn btn-secondary',
        },
        confirmButtonText: "تمام",
        cancelButtonText: "الغي",
        buttonsStyling: false
    })
})